import PropTypes from 'prop-types'
import * as Sc from './Heading.style'
import { TYPES_LEVELS } from './constants/levels'

const Heading = ({ children, level }) => {
  if (level === TYPES_LEVELS.TWO) {
    return <Sc.SecondLevel>{children}</Sc.SecondLevel>
  }
  if (level === TYPES_LEVELS.THREE) {
    return <Sc.ThirdLevel>{children}</Sc.ThirdLevel>
  }
  return <Sc.FisrtLevel>{children}</Sc.FisrtLevel>
}

Heading.propTypes = {
  children: PropTypes.node.isRequired,
  level: PropTypes.number.isRequired,
}

export default Heading
